import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Tab } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';

const BalanceSheetTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    width: '100%',
    marginRight: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    '&:focus': {
      opacity: 1,
    },
    '&:nth-child(odd)': {
      paddingRight: theme.spacing(0),
      marginRight: theme.spacing(1),
      '& .MuiTab-wrapper': {
        alignItems: 'flex-end',
        '& .MuiBox-root': {
          alignItems: 'flex-end',
        },
      },
    },
    '&:nth-child(even)': {
      paddingLeft: theme.spacing(0),
      marginLeft: theme.spacing(1),
      '& .MuiTab-wrapper': {
        alignItems: 'flex-start',
        '& .MuiBox-root': {
          alignItems: 'flex-start',
        },
      },
    },
  },
}))((props) => <Tab disableRipple {...props} />);

export default BalanceSheetTab;
